export const FEES_CALCULATOR_TRANSPORTATION_LOAD =
  'FEES_CALCULATOR_TRANSPORTATION_LOAD'
export const FEES_CALCULATOR_TRANSPORTATION_LOAD_FULFILLED =
  'FEES_CALCULATOR_TRANSPORTATION_LOAD_FULFILLED'
export const FEES_CALCULATOR_TRANSPORTATION_LOAD_REJECTED =
  'FEES_CALCULATOR_TRANSPORTATION_LOAD_REJECTED'
